<template>
  <div id="UrgentContact">
    <div class="pt-1">
      <div class="m-2">
        <van-cell class="text-left border-radius">
          <van-field v-model="UrgentContact" label="紧急联系人" placeholder="紧急联系人" />

          <van-field v-model="UrgentTel" label="紧急联系电话" placeholder="紧急联系电话" />
        </van-cell>

        <van-button plain hairline type="primary w-100 mt-4" @click="setPwdBtn">修改信息</van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UrgentContact",
  data() {
    return {
      title: "紧急联系人信息",
      UrgentContact: "",
      UrgentTel: ""
    };
  },
  methods: {
    setPwdBtn: function() {
      var json = {
        UrgentContact: this.UrgentContact,
        UrgentTel: this.UrgentTel
      };
      this.apiUserPut(json, this, e => {
        this.$toast(e.message);
        if (e.code == 1) {
          this.$router.push({
            name: "Setting"
          });
        }
      });
    }
  },
  created() {
    this.apiUserGet(this, res => {
      this.UrgentContact = res.data.UrgentContact;
      this.UrgentTel = res.data.UrgentTel;
    });
  }
};
</script>

<style scoped>
#UrgentContact {
  background: #efefef;
  min-height: 700px;
}
</style>
